export default __webpack_public_path__ + "static/media/aequalis18.8dbd09bd.pdf";